module.exports = __webpack_public_path__ + "static/img/zhongguosehuikexue.78b248d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ggw_img/zhongguosehuikexue.jpg
// module id = XfTX
// module chunks = 36